// useSelectors.ts
import { useSelector } from "react-redux";
var useSelectors = function () {
    var responseQuote = useSelector(function (state) { return ({
        responseQuote: state.Quote.responseQuote,
    }); }).responseQuote;
    var _a = useSelector(function (state) { return ({
        responseOneQuote: state.Quote.responseOneQuote,
        errorOneQuote: state.Quote.errorOneQuote,
    }); }), responseOneQuote = _a.responseOneQuote, errorOneQuote = _a.errorOneQuote;
    var _b = useSelector(function (state) { return ({
        responsePolicyConfirm: state.Policy.responsePolicyConfirm,
        responsePolicyConfirmError: state.Policy.errorPolicyConfirm,
        responsePolicyConfirmLoading: state.Policy.loadingPolicyConfirm,
    }); }), responsePolicyConfirm = _b.responsePolicyConfirm, responsePolicyConfirmError = _b.responsePolicyConfirmError, responsePolicyConfirmLoading = _b.responsePolicyConfirmLoading;
    return {
        responseQuote: responseQuote,
        responseOneQuote: responseOneQuote,
        errorOneQuote: errorOneQuote,
        responsePolicyConfirm: responsePolicyConfirm,
        responsePolicyConfirmError: responsePolicyConfirmError,
        responsePolicyConfirmLoading: responsePolicyConfirmLoading,
    };
};
export default useSelectors;
